import {Col, Row, Button} from 'antd';
import {FaPlus, FaRegWindowClose} from 'react-icons/fa';
import {useNavigate} from 'react-router-dom';
import IntlMessages from 'src/domain/utility/IntlMessages';

interface IProductRejectionReasonsHeaderProps {}

const ProductRejectionReasonsHeader = (
  props: IProductRejectionReasonsHeaderProps,
) => {
  const navigate = useNavigate();
  return (
    <Row gutter={[0, 20]} justify='space-between' className='fullContent'>
      <Col>
        <div className='text-title'>
          <span className='icon-title'>
            <FaRegWindowClose />
          </span>
          <IntlMessages id='productRejectionReasons.title' />
        </div>
      </Col>

      <Col>
        <Button
          icon={<FaPlus className='add-button-icon' />}
          onClick={() => navigate('/catalog/product-rejection-reasons/create')}
          type='primary'
          size='small'
          className='add-button'>
          <IntlMessages id='common.addNew' />
        </Button>
      </Col>
    </Row>
  );
};

export default ProductRejectionReasonsHeader;
